export class ProfilehelperDD {

  reportingtoLists = [];
  reportingtoEmployee = [];

}
